import { render, staticRenderFns } from "./courseType.vue?vue&type=template&id=18679d80&scoped=true"
import script from "./courseType.vue?vue&type=script&lang=js"
export * from "./courseType.vue?vue&type=script&lang=js"
import style0 from "./courseType.vue?vue&type=style&index=0&id=18679d80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18679d80",
  null
  
)

export default component.exports